const L="NEXT_LOCALE",E=31536e3,e="lax",l="X-NEXT-INTL-LOCALE",o="locale";export{L as COOKIE_LOCALE_NAME,E as COOKIE_MAX_AGE,e as COOKIE_SAME_SITE,l as HEADER_LOCALE_NAME,o as LOCALE_SEGMENT_NAME};
